module.exports = {"plate":{"semi":"Semi","material":"Material","surface":"Surface","thickness":"Thickness","drawingNo":"Drawing No.","rev":"Revision"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/plate.json
// module id = 937
// module chunks = 108